
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4 {...{
      "id": "job-ad-preview"
    }}>{`Job ad preview`}</h4>
    <p>{`We’ve extended `}<a parentName="p" {...{
        "href": "/use-cases/job-posting"
      }}>{`Job Posting`}</a>{` with the ability to `}<a parentName="p" {...{
        "href": "/use-cases/job-posting/managing-job-ads/previewing-a-job-ad"
      }}>{`preview a job ad`}</a>{` before it’s posted or updated.
This allows the hirer to understand how their job ad would be displayed in SEEK’s search results and job details page.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-scoobie-merged-code",
        "metastring": "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":null,\"value\":\"query ($positionProfile: PostedPositionProfilePreview_PositionProfileInput!) {\\n  postedPositionProfilePreview(positionProfile: $positionProfile) {\\n    previewUri {\\n      url\\n    }\\n  }\\n}\",\"position\":{\"start\":{\"line\":6,\"column\":1,\"offset\":240},\"end\":{\"line\":14,\"column\":4,\"offset\":440},\"indent\":[1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"positionProfile\\\": {\\n    \\\"positionTitle\\\": \\\"Senior Developer\\\",\\n    \\\"positionOrganizations\\\": \\\"seekAnzPublicTest:organization:seek:93WyyF1h\\\",\\n    \\\"jobCategories\\\": \\\"seekAnzPublicTest:jobCategory:seek:2EFstqFvP\\\",\\n    \\\"positionLocation\\\": \\\"seekAnzPublicTest:location:seek:2FqwWaaMV\\\",\\n    \\\"offeredRemunerationPackage\\\": {\\n      \\\"descriptions\\\": [\\\"Base + Super + Profit Share\\\"]\\n    },\\n    \\\"postingInstructions\\\": [\\n      {\\n        \\\"seekAdvertisementProductId\\\": \\\"globalPublicTest:adProduct:seekApi:EWHKTY9D6mJFiA5EH6P7MFbByJ1JVteAQQkfa3uMJLPJ\\\",\\n        \\\"brandingId\\\": \\\"globalPublicTest:advertisementBranding:hirerBranding:5DU2L2vQsyTXuu9NEUKT3f\\\"\\n      }\\n    ],\\n    \\\"positionFormattedDescriptions\\\": [\\n      {\\n        \\\"descriptionId\\\": \\\"AdvertisementDetails\\\",\\n        \\\"content\\\": \\\"My job ad details\\\"\\n      },\\n      {\\n        \\\"descriptionId\\\": \\\"SearchSummary\\\",\\n        \\\"content\\\": \\\"Search summary content\\\"\\n      },\\n      {\\n        \\\"descriptionId\\\": \\\"SearchBulletPoint\\\",\\n        \\\"content\\\": \\\"Search bullet point 1\\\"\\n      },\\n      {\\n        \\\"descriptionId\\\": \\\"SearchBulletPoint\\\",\\n        \\\"content\\\": \\\"Search bullet point 2\\\"\\n      },\\n      {\\n        \\\"descriptionId\\\": \\\"SearchBulletPoint\\\",\\n        \\\"content\\\": \\\"Search bullet point 3\\\"\\n      }\\n    ],\\n    \\\"seekAnzWorkTypeCode\\\": \\\"FullTime\\\",\\n    \\\"seekVideo\\\": {\\n      \\\"url\\\": \\\"https://www.youtube.com/watch?v=vsLYc3gzMzw\\\",\\n      \\\"seekAnzPositionCode\\\": \\\"Below\\\"\\n    }\\n  }\\n}\",\"position\":{\"start\":{\"line\":16,\"column\":1,\"offset\":442},\"end\":{\"line\":61,\"column\":4,\"offset\":1842},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":\"lovato-ignore-runnable-graphql-operation\",\"value\":\"{\\n  \\\"postedPositionProfilePreview\\\": {\\n    \\\"previewUri\\\": {\\n      \\\"url\\\": \\\"https://job-ad-preview.seek.com/anzPublicTest?id=seekAnzPublicTest:postedPositionProfilePreview:seekApi:37EWfWxhwVEGTT5BcjfE2L\\\"\\n    }\\n  }\\n}\",\"position\":{\"start\":{\"line\":63,\"column\":1,\"offset\":1844},\"end\":{\"line\":71,\"column\":4,\"offset\":2108},\"indent\":[1,1,1,1,1,1,1,1]}}]",
        "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":null,\"value\":\"query": true,
        "($positionProfile:": true,
        "PostedPositionProfilePreview_PositionProfileInput!)": true,
        "{\\n": true,
        "": true,
        "postedPositionProfilePreview(positionProfile:": true,
        "$positionProfile)": true,
        "previewUri": true,
        "url\\n": true,
        "}\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":6,\"column\":1,\"offset\":240},\"end\":{\"line\":14,\"column\":4,\"offset\":440},\"indent\":[1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
        "\\\"positionProfile\\\":": true,
        "\\\"positionTitle\\\":": true,
        "\\\"Senior": true,
        "Developer\\\",\\n": true,
        "\\\"positionOrganizations\\\":": true,
        "\\\"seekAnzPublicTest:organization:seek:93WyyF1h\\\",\\n": true,
        "\\\"jobCategories\\\":": true,
        "\\\"seekAnzPublicTest:jobCategory:seek:2EFstqFvP\\\",\\n": true,
        "\\\"positionLocation\\\":": true,
        "\\\"seekAnzPublicTest:location:seek:2FqwWaaMV\\\",\\n": true,
        "\\\"offeredRemunerationPackage\\\":": true,
        "\\\"descriptions\\\":": true,
        "[\\\"Base": true,
        "+": true,
        "Super": true,
        "Profit": true,
        "Share\\\"]\\n": true,
        "},\\n": true,
        "\\\"postingInstructions\\\":": true,
        "[\\n": true,
        "\\\"seekAdvertisementProductId\\\":": true,
        "\\\"globalPublicTest:adProduct:seekApi:EWHKTY9D6mJFiA5EH6P7MFbByJ1JVteAQQkfa3uMJLPJ\\\",\\n": true,
        "\\\"brandingId\\\":": true,
        "\\\"globalPublicTest:advertisementBranding:hirerBranding:5DU2L2vQsyTXuu9NEUKT3f\\\"\\n": true,
        "],\\n": true,
        "\\\"positionFormattedDescriptions\\\":": true,
        "\\\"descriptionId\\\":": true,
        "\\\"AdvertisementDetails\\\",\\n": true,
        "\\\"content\\\":": true,
        "\\\"My": true,
        "job": true,
        "ad": true,
        "details\\\"\\n": true,
        "\\\"SearchSummary\\\",\\n": true,
        "\\\"Search": true,
        "summary": true,
        "content\\\"\\n": true,
        "\\\"SearchBulletPoint\\\",\\n": true,
        "bullet": true,
        "point": true,
        "1\\\"\\n": true,
        "2\\\"\\n": true,
        "3\\\"\\n": true,
        "\\\"seekAnzWorkTypeCode\\\":": true,
        "\\\"FullTime\\\",\\n": true,
        "\\\"seekVideo\\\":": true,
        "\\\"url\\\":": true,
        "\\\"https://www.youtube.com/watch?v": "vsLYc3gzMzw\\\",\\n",
        "\\\"seekAnzPositionCode\\\":": true,
        "\\\"Below\\\"\\n": true,
        "}\\n}\",\"position\":{\"start\":{\"line\":16,\"column\":1,\"offset\":442},\"end\":{\"line\":61,\"column\":4,\"offset\":1842},\"indent\":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":\"lovato-ignore-runnable-graphql-operation\",\"value\":\"{\\n": true,
        "\\\"postedPositionProfilePreview\\\":": true,
        "\\\"previewUri\\\":": true,
        "\\\"https://job-ad-preview.seek.com/anzPublicTest?id": "seekAnzPublicTest:postedPositionProfilePreview:seekApi:37EWfWxhwVEGTT5BcjfE2L\\\"\\n",
        "}\\n}\",\"position\":{\"start\":{\"line\":63,\"column\":1,\"offset\":1844},\"end\":{\"line\":71,\"column\":4,\"offset\":2108},\"indent\":[1,1,1,1,1,1,1,1]}}]": true
      }}>{`query ($positionProfile: PostedPositionProfilePreview_PositionProfileInput!) {
  postedPositionProfilePreview(positionProfile: $positionProfile) {
    previewUri {
      url
    }
  }
}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;